import React from 'react';
import { Button } from '../ui/button';
import { Link2 } from 'lucide-react';

interface ConnectPlaceholderProps {
  message: string;
  onConnectClick: () => void;
}

const ConnectPlaceholder: React.FC<ConnectPlaceholderProps> = ({ message, onConnectClick }) => {
  const handleConnectClick = () => {
    // Only scroll to platform metrics section, don't trigger connection flow
    const platformMetricsSection = document.getElementById('platform-metrics-section');
    if (platformMetricsSection) {
      platformMetricsSection.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  };

  return (
    <div className="h-[300px] flex flex-col items-center justify-center bg-gray-50 dark:bg-slate-800/50 rounded-lg p-8 text-center">
      <p className="text-gray-500 dark:text-gray-400 mb-4">{message}</p>
      <button
        onClick={handleConnectClick}
        className="flex items-center space-x-2 text-white px-4 py-2.5 rounded-xl text-sm font-bold shadow-lg hover:shadow-xl transition-all duration-200 relative overflow-hidden"
        style={{ 
          background: 'linear-gradient(135deg, #30b3dd 0%, #4a298a 50%, #30b3dd 100%)',
          backgroundSize: '200% 200%',
          backgroundPosition: 'left center',
          boxShadow: '0 10px 25px rgba(48, 179, 221, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1) inset'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundPosition = 'right center';
          e.currentTarget.style.boxShadow = '0 15px 35px rgba(48, 179, 221, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.2) inset';
          e.currentTarget.style.transform = 'translateY(-2px) scale(1.05)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundPosition = 'left center';
          e.currentTarget.style.boxShadow = '0 10px 25px rgba(48, 179, 221, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1) inset';
          e.currentTarget.style.transform = 'translateY(0) scale(1)';
        }}
      >
        <Link2 className="h-4 w-4" />
        <span>Connect Accounts</span>
      </button>
    </div>
  );
};

export default ConnectPlaceholder;
